import React, { useState } from "react";
import { Link } from "react-router-dom";
import * as Images from "../../assets";
import Typewriter from 'typewriter-effect';
// import Aos from 'aos';

const HomePage = () => {
  // Aos.init();
  const [navbarOpen, setNavbarOpen] = useState(false); // State for the navbar toggle

  return (
    <div className="relative overflow-x-hidden">
      {/* Navbar */}
      <nav className="p-1 bg-customGreen border border-gray-200 rounded-full fixed top-4 left-1/2 transform -translate-x-1/2 z-50 shadow-md w-full max-w-screen-xl">
        <div className="flex items-center justify-between px-2">
          <a href="#home" className="flex flex-column items-center rtl:space-x-reverse">
            <img src={Images.logo} alt="Smart Chokidar" className="h-[4rem] w-auto" />
            <span className="text-2xl font-bold whitespace-nowrap text-blue-900">
              Smart Chokidar
            </span>
          </a>
          <button
            type="button"
            className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-300"
            onClick={() => setNavbarOpen(!navbarOpen)}
          >
            <span className="sr-only">Open main menu</span>
            <svg
              className="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h15M1 7h15M1 13h15"
              />
            </svg>
          </button>
          <div
            className={`absolute top-full left-0 w-full border border-white rounded-3xl bg-white transition-all duration-300 ${navbarOpen ? "block" : "hidden"
              } md:block md:relative md:w-auto md:bg-transparent`}
            id="navbar-default"
          >
            <ul className="font-bold flex flex-col 2xl:space-x-8 xl:space-x-8 l:space-x-8 md:flex-row md:space-x-3 rtl:space-x-reverse p-4 md:p-0 text-blue-900 md:bg-transparent">
              <li>
                <a className="block py-2 px-2 rounded hover:bg-gray-100 hover:text-blue-900 md:hover:bg-transparent md:hover:text-gray-500" href="#about" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">About Us</a>
                {/* <Link to="#about"
                  className="block py-2 px-4 rounded hover:bg-gray-100 hover:text-blue-900 md:hover:bg-transparent md:hover:text-gray-500"
                >
                  About Us
                </Link> */}
              </li>
              <li>
                <a className="block py-2 px-2 rounded hover:bg-gray-100 hover:text-blue-900 md:hover:bg-transparent md:hover:text-gray-500" href="#features" data-aos="fade-down" data-aos-duration="1500" data-aos-delay="200">Features</a>
                {/* <Link to="#features"
                  className="block py-2 px-4 rounded hover:bg-gray-100 hover:text-blue-900 md:hover:bg-transparent md:hover:text-gray-500"
                >
                  Features
                </Link> */}
              </li>
              <li>
                <a className="block py-2 px-2 rounded hover:bg-gray-100 hover:text-blue-900 md:hover:bg-transparent md:hover:text-gray-500" href="#whyWe" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">Why We</a>
                {/* <Link to="#whyWe"
                  className="block py-2 px-4 rounded hover:bg-gray-100 hover:text-blue-900 md:hover:bg-transparent md:hover:text-gray-500"
                >
                  Why We
                </Link> */}
              </li>
              <li>
                <a className="block py-2 px-2 rounded hover:bg-gray-100 hover:text-blue-900 md:hover:bg-transparent md:hover:text-gray-500" href="#faqs" data-aos="fade-down" data-aos-duration="1500" data-aos-delay="200">FAQs</a>
                {/* <Link to="#faqs"
                  className="block py-2 px-4 rounded hover:bg-gray-100 hover:text-blue-900 md:hover:bg-transparent md:hover:text-gray-500"
                >
                  FAQs
                </Link> */}
              </li>
              <li>
                <a className="block py-2 px-2 rounded hover:bg-gray-100 hover:text-blue-900 md:hover:bg-transparent md:hover:text-gray-500" href="#contact" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">Contact Us</a>
                {/* <Link to="#contact"
                  className="block py-2 px-4 rounded hover:bg-gray-100 hover:text-blue-900 md:hover:bg-transparent md:hover:text-gray-500"
                >
                  Contact Us
                </Link> */}
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <section id="home">
        <div className="fixed h-screen">
          <img
            src={Images.chokidar_bg_img}
            alt="Homepage"
            className="home-img absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 to-transparent opacity-90"></div>
          <div className="relative z-10 flex flex-col items-center justify-center text-center h-full px-6">
            <h1 className="text-4xl md:text-6xl font-bold leading-tight text-white drop-shadow-lg">
              <Typewriter options={{ strings: ['Make your society life simpler, safer, and smarter!', 'Live smarter, safer, and stress-free in your society!', 'Create a simpler, safer, and smarter society experience!'], autoStart: true, loop: true, }} />
            </h1>
            <p className="mt-4 text-lg md:text-xl text-white">
              One tap to remain connected, one tap to remain secure—your community is waiting!
            </p>
            <a href="#contact"
              className="mt-6 px-6 py-3 text-xl text-blue-900 font-bold bg-customGreen border border-gray-200 rounded-full shadow-md transition duration-300 transform btn-hover-img"
            >
              Contact Us <i className="fa fa-arrow-right"></i>
            </a>
          </div>
          <div className="absolute bottom-4 w-full text-center">
            <p className="text-lg md:text-xl text-white">Powered by Headway Business Solutions LLP</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;

